<template>
  <div>
    <Panel :data="feeHistory"/>
  </div>
</template>

<script>
import ModelMapper from '@/mixins/ModelMapper'
import Panel from '../Panel.vue'
import { mapMutations } from 'vuex'

export default {
  components: { Panel },
  computed: {
    feeHistory() {
      return this.getModel
    },
  },
  created() {
    this.asyncTemplateShow(this.id, {
      after: ({model}) => this.setNameBreadcrumb(model.id)
    })
  },
  data: () => ({
    modelPathPrefix: 'admin/maestro',
    nameModel: 'FeeHistory',
  }),
  methods: {
    ...mapMutations(['setNameBreadcrumb']),
  },
  mixins: [ModelMapper],
  name: 'Show',
  props: {
    id: { required: false }
  }
}

</script>

<style scoped>

</style>